import { createAsyncThunk } from '@reduxjs/toolkit'

import * as api from 'connections/restApi'

export const get = createAsyncThunk(
  'optimizationsDataToBeUpdated/get',
  async payload => {
    const response = await api.getOptimizationsDataToBeUpdated(payload)
    return response
  }
)
